import type { ListAlertsParams } from "@/lib/api/endpoints/alerts";
import { getAlert, listAlerts } from "@/lib/api/endpoints/alerts";

export type AlertsListQueryKeyParams = {
  tenantId?: string;
  deviceId?: string;
  workspaceScope?: "all";
  status?: "active" | "resolved";
  severity?: string;
  start?: string;
  end?: string;
};

export const alertsQueryKeys = {
  all: ["alerts"] as const,
  list: (p: AlertsListQueryKeyParams) =>
    [
      ...alertsQueryKeys.all,
      "list",
      p.tenantId ?? "",
      p.deviceId ?? "",
      p.workspaceScope ?? "",
      p.status ?? "",
      p.severity ?? "",
      p.start ?? "",
      p.end ?? "",
    ] as const,
  detail: (id: string) => [...alertsQueryKeys.all, "detail", id] as const,
};

export const alertsGateway = {
  fetchList: (params: ListAlertsParams) => listAlerts(params),
  fetchDetail: (alertId: string) => getAlert(alertId),
};
